import { useState } from "react";
import { C, font } from "../theme";
import { ApogeuLogo } from "../components/ApogeuLogo";
import { Button } from "../components/Button";
import { useSession } from "../lib/session/SessionContext";
import type { TenantMembershipDto } from "../types";

interface TenantSelectScreenProps {
  tenants: TenantMembershipDto[];
  onLogout: () => void;
}

export function TenantSelectScreen({ tenants, onLogout }: TenantSelectScreenProps) {
  const { switchTenant, error } = useSession();
  const [busyId, setBusyId] = useState<string | null>(null);

  const pick = async (tenantId: string) => {
    setBusyId(tenantId);
    await switchTenant(tenantId);
    setBusyId(null);
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: C.white,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        fontFamily: font,
        textAlign: "center",
      }}
    >
      <ApogeuLogo width={120} />
      <div style={{ fontSize: 22, fontWeight: 700, letterSpacing: 1.5, color: C.ink, marginTop: 18 }}>SELECIONE O CT</div>
      <div style={{ fontSize: 13, color: C.gray, marginTop: 8, maxWidth: 380, lineHeight: 1.6 }}>
        Você pertence a mais de um centro de treinamento. Escolha em qual deseja entrar.
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: 24, width: "100%", maxWidth: 340 }}>
        {tenants.map(t => (
          <button
            key={t.tenantId}
            onClick={() => pick(t.tenantId)}
            disabled={busyId !== null}
            style={{
              fontFamily: font,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              background: C.white,
              border: `1px solid ${C.faint}`,
              borderRadius: 12,
              padding: "14px 16px",
              cursor: busyId !== null ? "default" : "pointer",
              opacity: busyId !== null && busyId !== t.tenantId ? 0.5 : 1,
            }}
          >
            <span style={{ fontSize: 14, fontWeight: 700, color: C.ink }}>{t.name}</span>
            <span
              style={{
                fontSize: 10.5,
                fontWeight: 700,
                letterSpacing: 1,
                color: C.ink,
                background: C.limeSoft,
                padding: "3px 9px",
                borderRadius: 20,
                textTransform: "uppercase",
              }}
            >
              {busyId === t.tenantId ? "Entrando..." : t.roleSlug}
            </span>
          </button>
        ))}
      </div>
      {error && (
        <div style={{ fontSize: 12.5, color: C.red, background: "C.redSoft", borderRadius: 8, padding: "8px 12px", marginTop: 16 }}>
          {error}
        </div>
      )}
      <Button variant="ghost" onClick={onLogout} style={{ marginTop: 24, fontSize: 12.5 }}>
        Sair
      </Button>
    </div>
  );
}
